import { alpha } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";
import { getPrimaryGradient } from "assets/themes/themeTokens";

export const collapsedDrawerWidth = 72;
export const expandedDrawerWidth = 220;

export const getSidebarNavItemSx = (theme: Theme, expanded: boolean): SystemStyleObject<Theme> => ({
  minHeight: 50,
  borderRadius: expanded ? 3 : 2.5,
  px: expanded ? 1.5 : 1,
  justifyContent: expanded ? "flex-start" : "center",
  color: "text.secondary",
  "&.Mui-selected": {
    color: "common.white",
    background: getPrimaryGradient(theme),
    boxShadow: `0 8px 20px ${alpha(theme.palette.primary.main, 0.22)}`,
  },
  "&.Mui-selected:hover": {
    background: getPrimaryGradient(theme),
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
});

export const getSidebarNavIconSx = (expanded: boolean): SxProps<Theme> => ({
  minWidth: expanded ? 40 : 0,
  mr: expanded ? 0.5 : 0,
  color: "inherit",
  justifyContent: "center",
});

export const getSidebarPaperSx = (theme: Theme, expanded: boolean): SystemStyleObject<Theme> => ({
  top: 72,
  height: "calc(100% - 72px)",
  width: expanded ? expandedDrawerWidth : collapsedDrawerWidth,
  overflowX: "hidden",
  borderRight: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.background.paper, 0.96),
  backdropFilter: "blur(14px)",
  pt: 1,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
});

export const sidebarContentSx: SxProps<Theme> = {
  px: 1,
  py: 1.25,
  display: "grid",
  gap: 1.25,
};

export const getSidebarToggleRowSx = (expanded: boolean): SxProps<Theme> => ({
  display: "flex",
  justifyContent: expanded ? "flex-end" : "center",
});

export const getSidebarToggleButtonSx = (theme: Theme): SystemStyleObject<Theme> => ({
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  width: 34,
  height: 34,
});

export const sidebarListSx: SxProps<Theme> = {
  display: "grid",
  gap: 1,
  px: 0,
};
